import { VegaButton, VegaFont, VegaPageNotification } from '@globalpayments/vega-react';
import { useState } from 'react';

import DetailsModal from '../../../components/detailsModal';
import { UserRole, UserSummary } from '../../../types/users';
import RoleCheckboxes from './RoleCheckboxes';

interface EditRolesDialogProps {
  error?: Error | null;
  isPending: boolean;
  onClose: () => void;
  onSubmit: (roles: string[]) => void;
  open: boolean;
  user?: UserSummary;
}

/** Edits a selected user's role assignments. */
const EditRolesDialog = ({ error, isPending, onClose, onSubmit, open, user }: EditRolesDialogProps) => {
  const [roles, setRoles] = useState<string[]>(
    () => user?.roles.filter((role) => role !== UserRole.Basic) ?? [],
  );

  return (
    <DetailsModal
      backdrop="static"
      footerActions={
        <VegaButton
          disabled={!user || isPending}
          label={isPending ? 'Saving roles' : 'Save roles'}
          onVegaClick={() => onSubmit(roles)}
        />
      }
      modalTitle="Edit roles"
      onClose={onClose}
      open={open}>
      <VegaFont as="p">{user?.email}</VegaFont>
      {error && (
        <VegaPageNotification
          duration={0}
          message={error.message}
          notificationTitle="Role update failed"
          type="error"
        />
      )}
      <RoleCheckboxes onChange={setRoles} roles={roles} />
    </DetailsModal>
  );
};

export default EditRolesDialog;
